import { HistoricalDisbursementRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateHistoricalDisbursements = makeValidator({
  FieldParser: HistoricalDisbursementRow,
});
